function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Pair } from '../nodes/Pair.js';
import { YAMLMap } from '../nodes/YAMLMap.js';
import { resolveProps } from './resolve-props.js';
import { containsNewline } from './util-contains-newline.js';
import { flowIndentCheck } from './util-flow-indent-check.js';
import { mapIncludes } from './util-map-includes.js';
var startColMsg = 'All mapping items must start at the same column';

function resolveBlockMap(_ref, ctx, bm, onError, tag) {
  var _tag$nodeClass, _commentEnd;

  var composeNode = _ref.composeNode,
      composeEmptyNode = _ref.composeEmptyNode;
  var NodeClass = (_tag$nodeClass = tag === null || tag === void 0 ? void 0 : tag.nodeClass) !== null && _tag$nodeClass !== void 0 ? _tag$nodeClass : YAMLMap;
  var map = new NodeClass(ctx.schema);
  if (ctx.atRoot) ctx.atRoot = false;
  var offset = bm.offset;
  var commentEnd = null;

  var _iterator = _createForOfIteratorHelper(bm.items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _keyProps$found;

      var collItem = _step.value;
      var start = collItem.start,
          key = collItem.key,
          sep = collItem.sep,
          value = collItem.value; // key properties

      var keyProps = resolveProps(start, {
        indicator: 'explicit-key-ind',
        next: key !== null && key !== void 0 ? key : sep === null || sep === void 0 ? void 0 : sep[0],
        offset: offset,
        onError: onError,
        parentIndent: bm.indent,
        startOnNewline: true
      });
      var implicitKey = !keyProps.found;

      if (implicitKey) {
        if (key) {
          if (key.type === 'block-seq') onError(offset, 'BLOCK_AS_IMPLICIT_KEY', 'A block sequence may not be used as an implicit map key');else if ('indent' in key && key.indent !== bm.indent) onError(offset, 'BAD_INDENT', startColMsg);
        }

        if (!keyProps.anchor && !keyProps.tag && !sep) {
          commentEnd = keyProps.end;

          if (keyProps.comment) {
            if (map.comment) map.comment += '\n' + keyProps.comment;else map.comment = keyProps.comment;
          }

          continue;
        }

        if (keyProps.newlineAfterProp || containsNewline(key)) {
          onError(key !== null && key !== void 0 ? key : start[start.length - 1], 'MULTILINE_IMPLICIT_KEY', 'Implicit keys need to be on a single line');
        }
      } else if (((_keyProps$found = keyProps.found) === null || _keyProps$found === void 0 ? void 0 : _keyProps$found.indent) !== bm.indent) {
        onError(offset, 'BAD_INDENT', startColMsg);
      } // key value


      ctx.atKey = true;
      var keyStart = keyProps.end;
      var keyNode = key ? composeNode(ctx, key, keyProps, onError) : composeEmptyNode(ctx, keyStart, start, null, keyProps, onError);
      if (ctx.schema.compat) flowIndentCheck(bm.indent, key, onError);
      ctx.atKey = false;
      if (mapIncludes(ctx, map.items, keyNode)) onError(keyStart, 'DUPLICATE_KEY', 'Map keys must be unique'); // value properties

      var valueProps = resolveProps(sep !== null && sep !== void 0 ? sep : [], {
        indicator: 'map-value-ind',
        next: value,
        offset: keyNode.range[2],
        onError: onError,
        parentIndent: bm.indent,
        startOnNewline: !key || key.type === 'block-scalar'
      });
      offset = valueProps.end;

      if (valueProps.found) {
        if (implicitKey) {
          if ((value === null || value === void 0 ? void 0 : value.type) === 'block-map' && !valueProps.hasNewline) onError(offset, 'BLOCK_AS_IMPLICIT_KEY', 'Nested mappings are not allowed in compact mappings');
          if (ctx.options.strict && keyProps.start < valueProps.found.offset - 1024) onError(keyNode.range, 'KEY_OVER_1024_CHARS', 'The : indicator must be at most 1024 chars after the start of an implicit block mapping key');
        } // value value


        var valueNode = value ? composeNode(ctx, value, valueProps, onError) : composeEmptyNode(ctx, offset, sep, null, valueProps, onError);
        if (ctx.schema.compat) flowIndentCheck(bm.indent, value, onError);
        offset = valueNode.range[2];
        var pair = new Pair(keyNode, valueNode);
        if (ctx.options.keepSourceTokens) pair.srcToken = collItem;
        map.items.push(pair);
      } else {
        // key with no value
        if (implicitKey) onError(keyNode.range, 'MISSING_CHAR', 'Implicit map keys need to be followed by map values');

        if (valueProps.comment) {
          if (keyNode.comment) keyNode.comment += '\n' + valueProps.comment;else keyNode.comment = valueProps.comment;
        }

        var _pair = new Pair(keyNode);

        if (ctx.options.keepSourceTokens) _pair.srcToken = collItem;
        map.items.push(_pair);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (commentEnd && commentEnd < offset) onError(commentEnd, 'IMPOSSIBLE', 'Map comment with trailing content');
  map.range = [bm.offset, offset, (_commentEnd = commentEnd) !== null && _commentEnd !== void 0 ? _commentEnd : offset];
  return map;
}

export { resolveBlockMap };